import {useEffect, useState} from "react";
import {createColumnHelper} from "@tanstack/react-table";
import Card from "../../../components/UI/Card";
import Table from "../../../components/UI/Table";
import {getShippingMethods} from "../../../api/shippingMethods";
import {BrowserRouter as Router, Routes, Route, useSearchParams, useNavigate} from 'react-router-dom';
import Button from "../../../components/UI/Button";
import {checkPermission} from "../../../util/auth";


const ShippingMethodPageComponent = () => {
  let [searchParams, setSearchParams] = useSearchParams({per_page: 10});
  const navigate = useNavigate();
  useEffect(() => {
    if(!checkPermission(['SHIPPING_METHODS_VIEW'])){
      navigate("/no-access");
    }
  }, [navigate]);

  const setQueryParams = () => {
    const newSearchParams = new URLSearchParams();
    newSearchParams.set('foo', 'bar');
    newSearchParams.set('baz', 'qux');

    navigate({ search: newSearchParams.toString() });
  };


  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor('name', {
      id: 'name',
      header: 'Name'
    }),
    columnHelper.accessor('code', {
      id: 'code',
      header: 'Code'
    }),
    columnHelper.accessor('carrierCode', {
      id: 'carrierCode',
      header: 'Carrier Code'
    }),
    columnHelper.display( {
      id: 'status',
      header: 'Status',
      cell: props => <span className={'w_b_label'}>{props.row.original.status === '1' ? 'Active' : 'Inactive'}</span>
    }),
    columnHelper.display( {
      id: 'domestic',
      header: 'Domestic',
      cell: props => <span className={'w_b_label'}>{props.row.original.domestic === '1' ? 'Yes' : 'No'}</span>
    }),
    columnHelper.display( {
      id: 'international',
      header: 'International',
      cell: props => <span className={'w_b_label'}>{props.row.original.international === '1' ? 'Yes' : 'No'}</span>
    }),
    columnHelper.accessor('courier.name', {
      id: 'courier.name',
      header: 'Courier'
    }),

    columnHelper.accessor('fee', {
      id: 'fee',
      header: 'Fee',
      cell: props => <span> ${props.row.original.fee.toFixed(2)} </span>
    }),

  ];

  return (
    <>
      <Card title={"Shipping Methods"}>
        <Table
          queryKey={"shipping-methods"}
          columns={columns}
          queryParams={{per_page: 10}}
          queryFn={getShippingMethods}
        />
      </Card>
    </>
  )
}

export default ShippingMethodPageComponent